import { cn } from '@foam/buoy/src/lib/utils';
import { compactNumber } from '~/lib/numberUtils';

import { ChartDataPoint } from './utils';

export interface TooltipContentProps {
  active?: boolean;
  payload?: Array<{ payload: ChartDataPoint }>;
}

export const TooltipContent = ({ active, payload }: TooltipContentProps) => {
  if (!active || !payload?.length) {
    return null;
  }

  const data = payload[0].payload;

  // Skip tooltip for missing data points
  if (data.followers == null) {
    return null;
  }

  const isPositive = (data.followersGrowth ?? 0) > 0;
  const isNegative = (data.followersGrowth ?? 0) < 0;
  const hasGrowthRate = data.growthRate != null;
  const hasGrowthCount = data.followersGrowth != null;
  const growthRateLabel = hasGrowthRate
    ? `${(data.growthRate ?? 0) > 0 ? '+' : ''}${Number(
        (data.growthRate ?? 0) * 100,
      ).toFixed(1)}%`
    : '—';
  const growthCountLabel = hasGrowthCount
    ? `${(data.followersGrowth ?? 0) > 0 ? '+' : ''}${data.followersGrowth}`
    : '—';

  return (
    <div
      className="rounded-8 border border-neutral-100 bg-neutral-0 p-2 shadow-ground"
      role="tooltip"
      aria-label={`${data.month} follower statistics`}
    >
      <p className="mb-1 text-root-size-body-lg text-root-text-color-base">
        {data.month}
      </p>
      <table className="w-full">
        <tbody>
          <tr>
            <td className="pr-3 text-root-size-body-md font-root-text-weight-base text-root-text-color-subtle">
              Followers
            </td>
            <td className="text-right text-root-size-body-md font-root-text-weight-bold text-root-text-color-base">
              {compactNumber(data.followers ?? 0)}
            </td>
          </tr>
          <tr>
            <td className="pr-3 text-root-size-body-md font-root-text-weight-base text-root-text-color-subtle">
              MoM
            </td>
            <td
              className={cn(
                'text-right text-root-size-body-md font-root-text-weight-bold',
                {
                  'text-green-500': isPositive,
                  'text-red-500': isNegative,
                  'text-root-text-color-base': !isPositive && !isNegative,
                },
              )}
            >
              {growthRateLabel} ({growthCountLabel})
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
